import Admin from './Admins';                                //管理员导航
import SupplierHotel from './SupplierHotel';                 //供应商-酒店导航
import SupplierSales from './SupplierSales';                 //供应商-销售导航
import ProcurementEnterprise from './ProcurementEnterprise';                //采购商-企业
import ProcurementIndividual from './ProcurementIndividual';                //采购商-个人
export default {
    Admin:Admin,
    SupplierHotel:SupplierHotel,
    SupplierSales:SupplierSales,
    ProcurementEnterprise:ProcurementEnterprise,
    ProcurementIndividual:ProcurementIndividual
}